import { useContext, useEffect, useState } from 'react';
import Session from '../../classes/Session/Session';
import { useLocation } from 'react-router-dom';
import Translator from '../../classes/Translator/Translator';
import GeneralContext from '../../context/GeneralContext';

const LoginSectionLogic = (callback, validate, props, createSession) => {
  const { pathAfterLogin } = useContext(GeneralContext);
  const [values, setValues] = useState({
    ...props,
    client_id: '',
    password: '',
    showPassword: false,
    hasSession: new Session({}).hasSession(),
    showSuccess: false,
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const { translator } = Translator();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues((currentValues) => ({ ...currentValues, [name]: value }));
  };

  const handleClickShowPassword = () => {
    setValues((currentValues) => ({
      ...currentValues,
      showPassword: !currentValues.showPassword,
    }));
  };

  const handleMouseDownPassword = (e) => {
    e.preventDefault();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate(values);
    setErrors(validationErrors);
    const hasValidationErrors = Object.keys(validationErrors).length > 0;
    setIsSubmitting(!hasValidationErrors);
    setLoading(!hasValidationErrors);
  };

  const createSharedSession = async (data) => {
    const { id, token } = data;
    await createSession({ id, token });
  };

  /* function postCrossDomainMessage(msg) {
    const win = document.getElementById('ifr').contentWindow;
    win.postMessage(
      msg,
      `${process.env.REACT_APP_PERMITTED_DOMAIN_EGREEN}/session`
    );
  } */

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      setIsSubmitting(false);
      callback();
    }
  }, [errors, callback, isSubmitting]);

  useEffect(() => {
    if (location.state && location.state.callback) {
      setValues((currentValues) => ({
        ...currentValues,
        callback: location.state.callback,
      }));
    }
  }, [location.state]);

  return {
    errors,
    values,
    setValues,
    setErrors,
    translator,
    pathAfterLogin,
    handleChange,
    handleClickShowPassword,
    handleMouseDownPassword,
    handleSubmit,
    createSharedSession,
    loading,
    setLoading,
  };
};

export default LoginSectionLogic;
